import { useMediaQuery } from '@mantine/hooks';

const useIsMobile = (maxWidth?: number) => {
  // Read the media query on the first render: by default Mantine resolves it in an effect, so
  // every mount rendered the mobile layout for a frame (the header's "+" flashed in place of
  // « Aide vidéo » each time a routed drawer remounted the page).
  return (
    useMediaQuery(`(max-width: ${maxWidth ? maxWidth : 768}px)`, undefined, {
      getInitialValueInEffect: false,
    }) ?? true
  );
};

export default useIsMobile;
